import { createSlice } from '@reduxjs/toolkit';
import { Nullable, UserQuizResults } from '../../types';
import { takeOne } from '../../helpers/store';
import { Paginated } from '../../services/api-handlers/pagination';
import { getUserQuizResults } from '../thunks/user-quiz-result-thunks';
import { ReducerState } from '../configure-store';

export interface UserQuizResultState extends ReducerState {
    current: Nullable<Paginated<UserQuizResults>>;
}

const initialState: UserQuizResultState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
};

const slice = createSlice({
    name: 'user-quiz-result',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserQuizResults.pending, takeOne.pendingActionCase)
            .addCase(getUserQuizResults.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload as Paginated<UserQuizResults>;
            })
            .addCase(getUserQuizResults.rejected, takeOne.rejectedActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
